// Also translates errors saved by older generation jobs, without changing their codes or data.
export function routeGenerationMessage(error) {
    if (error?.code === 'EMPTY_ROUTE_PLANNING' || /^Parlevel returned no machines for route /i.test(error?.message || '')) {
        return 'Parlevel no devolvió máquinas para esta ruta en la fecha seleccionada.';
    }
    if (/^(Request failed|Network Error|timeout|Unexpected Parlevel|Parlevel request failed)/i.test(error?.message || '')) {
        return 'No se pudo consultar Parlevel. Actualice e intente nuevamente.';
    }
    const messages = {
        MISSING_LOCATION: 'Una máquina seleccionada no tiene ubicación.',
        MISSING_WAREHOUSE: 'No se encontró la bodega de esta ruta en Parlevel.',
        MISSING_COORDINATES: 'Una ubicación no tiene coordenadas válidas.',
        GOOGLE_ROUTES_NOT_CONFIGURED: 'La conexión con Google Routes no está configurada.',
        GOOGLE_ROUTE_FAILED: 'No se pudo calcular el recorrido con Google Routes.',
        GOOGLE_ROUTE_INCOMPLETE: 'Google Routes no pudo conectar todas las paradas.',
        PARLEVEL_CONTRACT_MISMATCH: 'Parlevel devolvió datos con un formato no reconocido.',
        PARLEVEL_ROUTE_AUTOMATION_DISABLED: 'La generación de propuestas está deshabilitada.',
        VERSION_CONFLICT: 'La propuesta cambió. Actualice antes de continuar.',
    };
    return messages[error?.code] || 'No se pudo generar la propuesta. Revise los datos de la ruta.';
}
